(function (angular) {
    'use strict';

    angular.module('Common')

        /**
         *
         */
        .factory('coreDataService',
            ['$http', '$q', 'portalConfig', 'sharedDataService', '$timeout',
                function ($http, $q, portalConfig, sharedDataService, $timeout) {
                    var _billingTimer;
                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getCountries: getCountries,
                        getBilling: getBilling,
                        getBillingNonAsync: getBillingNonAsync,
                        getServerTime: getServerTime,
                        sendTopUpRequest: sendTopUpRequest,
                        sendPackageChangeRequest: sendPackageChangeRequest,
                        uploadFile: uploadFile,
                        uploadGlobalFile: uploadGlobalFile,
                        uploadPrivateFile: uploadPrivateFile,
                        uploadGlobalPrivateFile: uploadGlobalPrivateFile
                    };

                    return fac;
                    function uploadGlobalPrivateFile(accountId, data, folder) {
                        return uploadFile(null, data, folder, accountId, true);
                    }
                    function uploadPrivateFile(apiSpaceId, data, folder) {
                        return uploadFile(apiSpaceId, data, folder, null, true);
                    }
                    function uploadGlobalFile(accountId, data, folder) {
                        return uploadFile(null, data, folder, accountId);
                    }

                    function uploadFile(apiSpace, data, folder, accountId, privateFile) {
                        var fd = new FormData();
                        fd.append('file', data);
                        var url;
                        if (!apiSpace && accountId) {
                            url = urlBase + "/accounts/" + accountId + "/content";
                        }
                        else {
                            url = urlBase + "/apispaces/" + apiSpace + "/content";
                        }
                        if (folder) {
                            url = url + '?folder=' + folder;
                            if (privateFile) {
                                url = url + '&private=true';
                            }
                        }
                        else if (!folder && privateFile) {
                            url = url + '?private=true';
                        }
                        return $http.post(url, fd, {
                            transformRequest: angular.identity,
                            headers: {
                                'Content-Type': undefined
                            }
                        })
                            .then(uploadFileComplete)
                            .catch(uploadFileFailed);

                        function uploadFileComplete(response) {
                            return response.data;
                        }

                        function uploadFileFailed(error) {
                            return $q.reject(error);
                        }
                    }
                    /**
                     * Method to get ALL the countries
                     * @returns {Promise} A promise that returns an array of countries (code and name)
                     */
                    function getCountries() {
                        if (sharedDataService.getCountries().length) {
                            return $q.resolve(sharedDataService.getCountries());
                        }
                        else {
                            return $http.get(urlBase + "/data/countries")
                                .then(getCountriesComplete)
                                .catch(getCountriesFailed);
                        }

                        function getCountriesComplete(response) {
                            sharedDataService.setCountries(response.data);
                            return sharedDataService.getCountries();
                        }

                        function getCountriesFailed(error) {
                            console.error("getCountriesFailed", error);
                            return $q.reject(error);
                        }
                    }

                    /**
                     * Method to get current server time
                     * @returns {Promise} A promise that returns object with currentServerTime property
                     */
                    function getServerTime() {

                        return $http.get(urlBase + "/data/servertime")
                            .then(getServerTimeComplete)
                            .catch(getServerTimeFailed);

                        function getServerTimeComplete(response) {
                            return response.data;
                        }

                        function getServerTimeFailed(error) {
                            console.error("getServerTimeFailed", error);
                            return $q.reject(error);
                        }
                    }

                    /**
                     * Method to get billing informations
                     * @returns {Promise} A promise that returns billing informations
                     */
                    function getBilling(accountId) {
                        if (_billingTimer) {
                            $timeout.cancel(_billingTimer);
                        }
                        return $http.get(urlBase + "/accounts/" + accountId + "/wallet", { async: true })
                            .then(getBillingComplete)
                            .catch(getBillingFailed);

                        function getBillingComplete(response) {
                            sharedDataService.setBilling(response.data);

                            _billingTimer = $timeout(function () {
                                return getBilling(accountId);
                            }, 600000);
                        }

                        function getBillingFailed(error) {
                            console.error("getBillingFailed", error);
                            return $q.reject(error);
                        }
                    }
                    /**
                  * Method to get billing informations
                  * @returns {Promise} A promise that returns billing informations
                  */
                    function getBillingNonAsync(accountId) {

                        return $http.get(urlBase + "/accounts/" + accountId + "/wallet")
                            .then(getBillingComplete)
                            .catch(getBillingFailed);

                        function getBillingComplete(response) {
                            return response.data;
                        }

                        function getBillingFailed(error) {
                            console.error("getBillingFailed", error);
                            return $q.reject(error);
                        }
                    }
                    /**
                     * Method to send top up request
                     */
                    function sendTopUpRequest(data) {

                        return $http.post(urlBase + '/billing/requests/topup', data)
                            .then(sendRequestComplete)
                            .catch(sendRequestFailed);

                        function sendRequestComplete(response) {
                            return response.data;
                        }

                        function sendRequestFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }


                    }
                    /**
                    * Method to send change package request
                    */
                    function sendPackageChangeRequest(data) {

                        return $http.post(urlBase + '/billing/requests/changepackage', data)
                            .then(sendRequestComplete)
                            .catch(sendRequestFailed);

                        function sendRequestComplete(response) {
                            return response.data;
                        }

                        function sendRequestFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }


                    }

                }]);

})(window.angular);
